module.exports = __webpack_public_path__ + "static/media/account_reset_v2.786c7dce.jpg";